import React from "react";

import DateInput from "./DateInput";

export default function TimeInput({ value, ...props }) {
	if (typeof value === "string" && value.length === 5) {
		const [hours, minutes] = value.split(":");

		value = new Date();
		value.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);
	}

	return (
		<DateInput value={value} dateFormat="HH:mm" showTimeSelect showTimeSelectOnly placeholder="00:00" {...props} />
	);
}
